import { ACTIONS, ROLES } from './constants'

/**
 * Check if user is authorized to perform an action given its privilege.
 *
 * @param {String} params.capability User privilege
 * @param {String} params.action Action to perform
 */
function userIsAuthorized(params) {
  const capability = params.capability
  const action = params.action

  return ACTIONS.indexOf(capability) <= ACTIONS.indexOf(action)
}

/**
 * Check if user role is authorized to perform an action to another role.
 *
 * @param {String} params.capability User privilege
 * @param {String} params.action Action to perform
 */
function roleIsAuthorized(params) {
  const userRole = params.userRole
  const neededRole = params.neededRole

  return ROLES.indexOf(userRole) <= ROLES.indexOf(neededRole)
}

export { userIsAuthorized, roleIsAuthorized }
